import BaseApiRequest from "./BaseApiRequest";
import { APPLICATION_LIST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetApplicationListRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = getCurrentUserParameters(
    `${APPLICATION_LIST_URL}?t=${new Date().getTime()}`
  );

  getMethod = () => this.method;

  getUrl = () => {
    return this.url;
  };

  getBody = () => this.body;
}
